import React, { FC, useEffect } from "react"

import { observer } from "mobx-react"
import { Button, Form, Input, Select, Switch } from "antd"

import { useStore } from "stores/utils/use-store"
import { SubmitCancelButtons } from "components"
import { GameCategoryOrderBaseType, GameCategoryOrderType } from "./store/game-category-order.store"

interface EditGamesModalProps { editType: "create" | "edit"; onClose: () => void, onSubmit: (e: any) => void }

export const EditGamesModals: FC<EditGamesModalProps> = observer(({ editType, onClose, onSubmit }) => {
  const [form] = Form.useForm()
  const { dataStore: { gameCategoryOrderStore } } = useStore()

  useEffect(() => {
    if (editType === "edit" && gameCategoryOrderStore.selectedElement) {
      form.setFieldsValue({
        name: gameCategoryOrderStore.selectedElement.name,
        isActive: gameCategoryOrderStore.selectedElement.isActive,
        categories: gameCategoryOrderStore.selectedElement.categories,
      })
    }

    if (editType === "create") {
      form.resetFields()
    }
  }, [editType, gameCategoryOrderStore.selectedElement, form])


  const onFinishHandler = async(e: GameCategoryOrderBaseType) => {
    await onSubmit({ ...e, id: gameCategoryOrderStore.selectedElement.id })
    gameCategoryOrderStore.selectedElement = {} as GameCategoryOrderType
    onClose()
  }

  const onFinishFailedHandler = (e: any) => {
    console.log(e)
  }

  return (
    <Form form={form} onFinish={onFinishHandler} onFinishFailed={onFinishFailedHandler}>
      <Form.Item
        label="Name"
        name="name"
        rules={[{ required: true, message: "Please input game's name!" }]}
      >
        <Input maxLength={25} />
      </Form.Item>

      {editType === "edit" ? (
        <Form.Item label="Active" name="isActive" valuePropName="checked">
          <Switch />
        </Form.Item>
      ) : null}

      <Form.List name="categories" initialValue={editType === "edit" ? [] : []}>
        {(fields, { add, remove, move }) => (
          <>
            {fields.map(({ key, name, ...restField }, index) => (
              <div
                key={key}
                style={{
                  marginBottom: 16,
                  border: "1px solid #ccc",
                  padding: 16,
                  borderRadius: 4,
                  position: "relative",
                }}
              >
                <div style={{ position: "absolute", right: 8, top: 8, display: "flex", flexDirection: "column", gap: 4 }}>
                  <Button
                    size="small"
                    onClick={() => index > 0 && move(index, index - 1)}
                    disabled={index === 0}
                  >
                    ↑
                  </Button>
                  <Button
                    size="small"
                    onClick={() => index < fields.length - 1 && move(index, index + 1)}
                    disabled={index === fields.length - 1}
                  >
                    ↓
                  </Button>
                </div>

                <Form.Item
                  {...restField}
                  label="Category Name"
                  name={[name, "name"]}
                  rules={[{ required: true, message: "Missing category name" }]}
                  style={{ paddingRight: 30 }}
                >
                  <Input placeholder="Category name" />
                </Form.Item>

                <Form.Item
                  {...restField}
                  label="Games"
                  name={[name, "platformIds"]}
                  rules={[{ required: true, message: "Enter at least one platform ID" }]}
                >
                  <Select
                    mode="tags"
                    placeholder="Enter platform IDs"
                    options={
                      (gameCategoryOrderStore.platformIds || [])
                        .map(game => game.platforms.map(p => ({
                          label: p.platformId,
                          value: p.platformId,
                        })))
                        .reduce((acc, val) => acc.concat(val), [])
                    }
                  />
                </Form.Item>

                <Button type="link" danger onClick={() => remove(name)}>
                  Remove Category
                </Button>
              </div>
            ))}
            <Form.Item>
              <Button type="dashed" onClick={() => add({ name: "", platformIds: [] })} block icon="+">
                Add Category
              </Button>
            </Form.Item>
          </>
        )}
      </Form.List>
      <SubmitCancelButtons onClose={onClose} isLoading={false} />
    </Form>
  )
})
